import { IPinActionButtonStyleProps, IPinActionButtonProps } from './PinActionButton.types';
import { PinActionButtonBase } from './PinActionButton.base';
import { styled, IButtonStyles } from '@fluentui/react';
import { getStyles } from './PinActionButton.styles';

export const PinActionButton = styled<
    IPinActionButtonProps,
    IPinActionButtonStyleProps,
    IButtonStyles
>(PinActionButtonBase, getStyles, undefined, {
    scope: 'PinActionButton',
});

PinActionButton.displayName = 'PinActionButton';
